import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
	selector: '[appHeightMask]'
})
export class HeightMaskDirective {
	private isBackspacing = false;

	constructor(
		private el: ElementRef,
		private control: NgControl
	) {}

	@HostListener('input', ['$event'])
	onInputChange(): void {
		if (this.isBackspacing) {
			// ignore backspacing input triggers
			this.isBackspacing = false;
			return;
		}

		const input = this.el.nativeElement as HTMLInputElement;
		let value = input.value.replace(/[^\d]/g, '');

		if (value.length > 3) value = value.slice(0, 3);

		let formattedVal = '';

		if (value.length === 3) {
			// format as F'II"
			formattedVal = `${value[0]}'${value.slice(1, 3)}"`;
		} else if (value.length === 2) {
			// format as F'I"
			formattedVal = `${value[0]}'${value[1]}"`;
		} else if (value.length === 1) {
			// format as F'
			formattedVal = `${value[0]}'`;
		}

		input.value = formattedVal;

		// update the form control value with the formatted value
		this.control.control?.setValue(formattedVal);
	}

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent): void {
		const input = this.el.nativeElement as HTMLInputElement;

		if (event.key === 'Backspace') {
			if (input.value.endsWith('"')) {
				event.preventDefault();
				this.isBackspacing = true;
				if (input.value.length > 2) {
					input.value = input.value.slice(0, -2); // remove last digit and "
				} else {
					input.value = ''; // clear the input if only " is left
				}
			} else if (input.value.endsWith("'")) {
				event.preventDefault();
				this.isBackspacing = true;
				if (input.value.length > 1) {
					input.value = input.value.slice(0, -1); // remove last digit and '
				} else {
					input.value = ''; // clear the input if only ' is left
				}
			}
		}
	}
}
